import { useState } from "react"
import { Box, Button } from "@mui/material"
import { attachProductsToDiscount } from "@/api/discountService"
import { toast } from "sonner"
import { useQueryClient } from "@tanstack/react-query"
import ProductSelector from "@/pages/discount/ProductSelector"
import DiscountProductTable from "./DiscountProductTable"
import { DiscountImport } from "./DiscountImport"

export default function DiscountProductManager({ discount, finalPrice }) {
  const [showProductSelector, setShowProductSelector] = useState(false)
  const queryClient = useQueryClient()

  const discountId = discount?.id

  const handleAttach = (productIds) => {
    attachProductsToDiscount(discountId, productIds).then(() => {
      toast.success("Products added successfully")

      queryClient.invalidateQueries({
        queryKey: ["discount", String(discountId)],
      })

      setShowProductSelector(false)
    })
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: "20px",
        }}
      >
        <h4>Products ({discount?.products?.length || 0})</h4>

        {(discount?.type === "percentage" || discount?.type === "fixed") && (
          <Button
            variant="contained"
            onClick={() => setShowProductSelector(true)}
          >
            Add Products
          </Button>
        )}
      </Box>

      {/* PURE TABLE */}
      <DiscountProductTable
        discount={discount}
        discountId={discountId}
        finalPrice={finalPrice}
      />

      {/* MODAL ONLY HERE */}
      {showProductSelector && (
        <ProductSelector
          open={showProductSelector}
          onClose={() => setShowProductSelector(false)}
          onSelect={handleAttach}
          selectedProductIds={discount?.products?.map((p) => p.id) || []}
        />
      )}
    </Box>
  )
}
